const VOLUNTARY_LOGOUT_STORAGE_KEY = "festi:voluntary-logout-at";
const VOLUNTARY_LOGOUT_MAX_AGE_MS = 5000;

export const markVoluntaryLogout = () => {
  if (typeof window === "undefined") return;

  window.sessionStorage.setItem(VOLUNTARY_LOGOUT_STORAGE_KEY, Date.now().toString());
};

export const consumeVoluntaryLogout = () => {
  if (typeof window === "undefined") return false;

  const value = window.sessionStorage.getItem(VOLUNTARY_LOGOUT_STORAGE_KEY);

  if (!value) return false;

  window.sessionStorage.removeItem(VOLUNTARY_LOGOUT_STORAGE_KEY);

  const loggedOutAt = Number(value);

  return Number.isFinite(loggedOutAt) && Date.now() - loggedOutAt < VOLUNTARY_LOGOUT_MAX_AGE_MS;
};
